// extracted by mini-css-extract-plugin
module.exports = {"root":"NotAcceptingOrdersModal_root__32xfj","wrapper":"NotAcceptingOrdersModal_wrapper__1VhP_","title":"NotAcceptingOrdersModal_title__1nMNO"};